import React from "react"
import styled from "styled-components";

const CloseBlockWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  padding-bottom: 20px;
  padding-top: 10px;
  cursor: pointer;
`

const CloseBlockItem = styled.span`
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
  border: 1px solid white;
  padding: 5px;
  background-color: mediumpurple;
  color: #fff;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const CloseBtn = ({count, clearDelay}) => {
    return (
        <>
            {count !== 0
                ? <CloseBlockWrapper>
                    <CloseBlockItem>{count}</CloseBlockItem>
                </CloseBlockWrapper>
                : <CloseBlockWrapper onClick={clearDelay}>
                    <CloseBlockItem>Х</CloseBlockItem>
                </CloseBlockWrapper>
            }
        </>
    )
}

export default CloseBtn